// new Tabs(); 

$(document).ready(function () {

	var imask = new Inputmask('+7 (999) 999-99-99');

	$('[type=tel]').each(function () {
		imask.mask(this)
	});

	$('.js-next-scroll__btn').click(function (e) {
		e.preventDefault();
		var nextSectionTop = $(this).closest('.section').next().offset().top;
		$('body,html').animate({
			scrollTop: nextSectionTop
		}, 1000)
	});

	// $(document).scroll(function(event) {
	// 	if ($('html,body').scrollTop() > 0) {
	// 		$('#js-header').addClass('active');
	// 	} else {
	// 		$('#js-header').removeClass('active');
	// 	}
	// });

	var giftFormContainer = $('#js-form-free-container'),
		buyFormContainer = $('#js-form-buy-container');

	giftFormContainer.on('submit', '#js-form-free', function () {

		var waitFree = BX.showWait(giftFormContainer[0]);
		data = $(this).serialize();
		giftFormContainer.find('[type="submit"]').attr('disabled', 'disabled');

		$.ajax({
			type: 'POST',
			url: '/giftcard/include/form_free.php',
			data: data,
			success: function (data) {
				giftFormContainer.html(data);
				giftFormContainer.find('[type=tel]').each(function () {
					imask.mask(this)
				});
				BX.closeWait(giftFormContainer[0], waitFree);
				giftFormContainer.find('[type="submit"]').removeAttr('disabled');
			},
			error: function (xhr, ajaxOptions, thrownError) {
				giftFormContainer.html('<div class="form__message form__message_error">Ошибка</div>');
				BX.closeWait(giftFormContainer[0], waitFree);
			}
		});

		return false;

	});

	buyFormContainer.on('submit', '#js-form-buy', function () {

		var waitBuy = BX.showWait(buyFormContainer[0]);
		data = $(this).serialize();
		buyFormContainer.find('[type="submit"]').attr('disabled', 'disabled');

		$.ajax({
			type: 'POST',
			url: '/giftcard/include/form_buy.php',
			data: data,
			success: function (data) {
				buyFormContainer.html(data);
				buyFormContainer.find('[type=tel]').each(function () {
					imask.mask(this)
				});
				BX.closeWait(buyFormContainer[0], waitBuy);
				buyFormContainer.find('[type="submit"]').removeAttr('disabled');
			},
			error: function (xhr, ajaxOptions, thrownError) {
				buyFormContainer.html('<div class="form__message form__message_error">Ошибка</div>');
				BX.closeWait(buyFormContainer[0], waitBuy);
			}
		});

		return false;

	});
})